import React, { FunctionComponent } from 'react';
import * as graphCMS from '../../../domain/graphcms';
import ArticleMarkdown from '../article-markdown/ArticleMarkdown';
import * as styles from './ArticleBlock.style';

export interface ArticleBlockProps extends graphCMS.ArticleBlock {}

const ArticleBlock: FunctionComponent<ArticleBlockProps> = ({
  id,
  title,
  content,
}) => (
  <div
    css={styles.article}
  >
    <div
      id={id}
      css={styles.anchor}
    />
    <h2 css={styles.title}>
      {title}
    </h2>
    <ArticleMarkdown>
      {content}
    </ArticleMarkdown>
  </div>
);

export default ArticleBlock;
